/**
 * Module dependencies.
 */

import { JSX, ReactNode } from 'react';
import { LocaleString } from 'types/locale-string';
import { useTranslation } from 'next-i18next';

/**
 * `Props` type.
 */

type Props = {
  children: (value: string) => ReactNode;
  value: LocaleString;
};

/**
 * Export `ResolveLocaleString` component.
 */

export function ResolveLocaleString({ children, value }: Props): JSX.Element {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <>
      {children(value?.[lang] ?? value?.[i18n.options.fallbackLng as string])}
    </>
  );
}
